export default __webpack_public_path__ + "98c6545227a6c60918a3076bb86165c7.png";